import React from "react";
import { Button, Fade, Link, Modal } from "@mui/material";
import { UNSAVE_DIALOG_ACTIONS } from "./models/user-interface";

interface ModalProps {
  showUnsavedModal: boolean;
  handleUnsavedWanringModalAction: (action: string) => void;
}
export default function UnsaveChangeDialog(props: ModalProps) {
  const { showUnsavedModal, handleUnsavedWanringModalAction } = props;

  return (
    <Modal
      open={showUnsavedModal}
    >
      <Fade in={showUnsavedModal}>
        <div className="e-sign__modal">
          <h4>You have unsaved changes </h4>
          <p>
            Navigating away without saving will lose any changes you have made.
          </p>
          <div className="e-sign__modal--buttons">
            <Button
              variant="contained"
              className="btn-primary"
              onClick={() => {
                handleUnsavedWanringModalAction(UNSAVE_DIALOG_ACTIONS.SAVE);
              }}
            >
              Save Changes
            </Button>
            <Button
              variant="contained"
              className="btn-secondary"
              onClick={() => {
                handleUnsavedWanringModalAction(UNSAVE_DIALOG_ACTIONS.DISCARD);
              }}
            >
              Disacard Changes
            </Button>
            <Link
              className="primary-link"
              onClick={() => {
                handleUnsavedWanringModalAction(
                  UNSAVE_DIALOG_ACTIONS.KEEP_EDITING
                );
              }}
            >
              Keep Editing
            </Link>
          </div>
        </div>
      </Fade>
    </Modal>
  );
}
